module.exports = __webpack_public_path__ + "static/media/Arzuros.b8bcdd61.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Arzuros.png
// module id = 92
// module chunks = 0